<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <!--<div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="12" style="margin:0px 0px 16px 0px;">
          <a-col class="a-large-form">
            <a-form-item
            style="margin-bottom:0px"
            label=""
            :required="false"
          >
            <a-select defaultValue="全部积分类型" >
              <a-select-option value="0">全部积分类型</a-select-option>
              <a-select-option value="0">兑换</a-select-option>
              <a-select-option value="1">获取</a-select-option>
            </a-select>
          </a-form-item>
          </a-col>

        
          <a-button type="primary" @click="searchQuery" style="margin-right:10px;margin-left:5px;">筛选</a-button>
          <a-button type="primary" @click="goodsCreate" icon="plus" style="margin-right:10px;float:right;">新建积分规则</a-button>
          

        </a-row>
      </a-form>
    </div>-->
    <div>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="ruleEdit(record)">编辑</a>

        </span>

      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <!-- <courseCreate-modal ref="modalForm" @ok="modalFormOk"/> -->

  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  // import CourseCreateModal from '../../../components/myCourse/myCourseList/CourseCreateModal'

  export default {
    name: "PointsRulesList",
    mixins: [JeecgListMixin],
    components: {
      
    },
    data () {
      return {
        queryParam:{
        },
        // firstIsNotLoad:true,
        description: '积分规则管理页面',
        // 表头
        columns: [
         
          {
            title: '积分类型',
            align:"center",
            dataIndex: 'scoreType',
            width:200,
            customRender: (text, row, index) => {
              
              return (<span >{row.scoreType==1?"获取积分":"兑换积分"}</span>)
              
            }
          },
          // {
          //   title: '参与课程或商品数',
          //   align:"center",
          //   dataIndex: 'ruleDesc',
          //   width:100
          // },
          {
            title: '积分规则',
            align:"center",
            dataIndex: 'ruleDesc',
            width:260
          },
          {
            title: '规则更新时间',
            align:"center",
            dataIndex: 'updateTime',
            width:180
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            width:150,
            scopedSlots: { customRender: 'action' },
          }
        ],
        dataSource:[],
        // 请求参数
    	url: {
              list: "/pc/score/rule/list",
              delete: "/operation/pc/do",
              deleteBatch: "/course/elinkxCourse/deleteBatch",
              exportXlsUrl: "course/elinkxCourse/exportXls",
              importExcelUrl: "course/elinkxCourse/importExcel",
           },
        }
      },
      computed: {
        importExcelUrl: function(){
          return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
        }
      },


    methods: {

      ruleEdit(item){
        this.$router.push({ path:'/pointsManage/pointRulesCreate?id='+item.id+"&type="+item.scoreType+'&value1='+item.value1+'&value2='+item.value2});
      }

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>